<template>
  <div style="position: relative">
    <a-icon class="a-icon" type="plus-circle"/>
    <div class="ant-input" @click="openModal" v-if="!disabled">
      <template v-for="tag in returnValue">
        <a-tooltip :key="tag.deptId" :title="tag.deptName" v-if="type === 'dept'">
          <a-tag :key="tag.deptId" :closable="true" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.deptName }}
          </a-tag>
        </a-tooltip>
        <a-tooltip :key="tag.userId" :title="tag.userName" v-else>
          <a-tag :key="tag.userId" :closable="true" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.userName }}
          </a-tag>
        </a-tooltip>
      </template>
      <a-tooltip :key="1000001" :title="`删除全部`">
        <a-tag :key="1000001" @click.stop="closeAll" style="margin: 3px" :visible="returnValue.length > 0">
          删除全部
        </a-tag>
      </a-tooltip>
    </div>
    <div class="ant-input" v-else>
      <template v-for="tag in returnValue">
        <a-tooltip :key="tag.deptId" :title="tag.deptName" v-if="type === 'dept'">
          <a-tag :key="tag.deptId" :closable="false" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.deptName }}
          </a-tag>
        </a-tooltip>
        <a-tooltip :key="tag.userId" :title="tag.userName" v-else>
          <a-tag :key="tag.userId" :closable="false" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.userName }}
          </a-tag>
        </a-tooltip>
      </template>
    </div>
    <a-modal forceRender
             v-model="visible"
             :title="title"
             :width="1200"
             ok-text="确认"
             cancel-text="取消"
             @ok="handleOk"
    >
      <div class="tag-select">
        <a-radio-group v-model="type" @change="handleChange">
          <a-radio-button value="customer">
            员工
          </a-radio-button>
          <a-radio-button value="dept">
            部门
          </a-radio-button>

        </a-radio-group>
        <div>
          <vxe-button @click="chooseAll" style="margin-top: 12px" v-if="type === 'customer'">全选可见员工</vxe-button>
          <a-button @click="closeAll" style="margin-top: 12px;float: right;" type="primary">清空已选</a-button>
          <vxe-button @click="resetAll" style="margin-top: 12px">重置列表</vxe-button>

        </div>
        <div class="user-box">
          <div class="left">
            <div class="search-box">
              <a-input placeholder="搜索部门/员工" v-model="kws"/>
              <a-button type="primary" @click="onSearch">搜索</a-button>
            </div>
            <div class="tree-box" v-if="type === 'dept'">
              <!--                  书签-->
              <a-tree

                  v-model="checkedKeys"
                  checkable
                  :expanded-keys="expandedKeys"
                  :auto-expand-parent="autoExpandParent"
                  :selected-keys="selectedKeys"
                  :tree-data="treeData"
                  :selectable="false"
                  :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
                  @expand="onExpand"
                  @check="onSelect"
              />
            </div>
            <div class="tree-box" v-if="type === 'customer'">

              <Tree
                  v-if="treeData.length"
                  defaultExpandAll=true
                  :list="treeData"
                  :selectedUser="selectedUser"
                  :userName="kws"
                  :detph="0"
                  @change="checkedUser"></Tree>
            </div>
          </div>
          <div class="right">
            <div>已选择的成员</div>
            <ul class="selected" v-if="type === 'dept'">
              <li v-for="item in selectedData" :key="item.key">
                <span>{{ item.deptName }}</span>
                <a-icon type="close" @click="deleteItem(item.deptId)"/>
              </li>
            </ul>
            <ul class="selected" v-if="type === 'customer'">
              <li v-for="item in selectedUser" :key="item.userId">
                <span>{{ item.userName }}</span>
                <a-icon type="close" @click="deleteUser(item.userId)"/>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </a-modal>
  </div>

</template>

<script>
import {dataApi} from '@/services/comm/userPickerWithNoParents.js';
import Tree from "./TreeWithNoParents";
import XEUtils from "xe-utils/index";

export default {
  components: {Tree},
  data() {
    return {
      visible: false,
      selected: [],
      type: 'customer',
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      selectedData: [],
      selectedUser: [],
      treeData: [],
      kws: '',
      returnValue: []
    };
  },
  // model: {
  //   prop: 'value',
  //   event: 'rtValue'
  // },
  props: {
    title: {
      type: String
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      dataApi.popSelect(this.kws).then(res => {
        console.log(res.data);
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
        console.log(169,this.treeData);
      })

    },
    onSearch() {
      if (this.kws === '') {
        this.init()
      } else {
        if (this.type === 'customer') {
          dataApi.popSelectWithUser(this.kws).then(res => {
            this.treeData = XEUtils.toArrayTree(res.data, {
              parentKey: 'parentId',
              key: 'deptId',
              children: 'children',
            })
            if (res.data.length === 0) {
              this.$message.error('暂无匹配结果，请重新输入员工')
            }
          })
        } else {
          dataApi.popSelect(this.kws).then(res => {
            this.treeData = XEUtils.toArrayTree(res.data, {
              parentKey: 'parentId',
              key: 'deptId',
              children: 'children'
            })
            if (res.data.length === 0) {
              this.$message.error('暂无匹配结果，请重新输入部门')
            }
          })
        }
      }

    },
    handleChange() {
      this.kws = ''
      this.closeAll()
      this.onSearch()
    },
    openModal() {
      this.visible = true
    },
    handleOk() {
      if (this.type === 'dept') {
        this.returnValue = this.selectedData
      } else {
        this.returnValue = this.selectedUser
      }
      this.visible = false;
    },
    tagClose(removedTag) {
      if (this.type === 'dept') {
        this.deleteItem(removedTag.deptId)
      } else {
        this.deleteUser(removedTag.userId)
      }
      this.returnValue = this.returnValue.filter(item => item !== removedTag)
    },
    closeAll() {

      if (this.type === 'dept') {
        this.checkedKeys = []
        this.selectedData = []
      } else {
        XEUtils.mapTree(this.treeData, item => {
          if (item.userList) {
            item.userList.map(user => {
              user.checked = false
            })
          }
          return item
        })
        this.selectedUser = []
      }
      this.returnValue = []
    },
    resetAll(){
      this.kws = ''
      this.init()
    },
    chooseAll() {
      //书签
      XEUtils.mapTree(this.treeData, item => {
        console.log(item)
        if (item.userList&&item.showUser===true) {
          item.userList.map(user => {
            user.checked = true
            if ((!this.selectedUser.includes(user)))
              this.selectedUser.push(user)
          })
        }
        return item
      })
    },
    deleteItem(deptId) {
      const idlist = this.getIds(deptId)
      this.checkedKeys = this.checkedKeys.filter(item => !idlist.includes(item))
      this.selectedKeys = this.selectedKeys.filter(item => !idlist.includes(item))
      this.selectedData = this.selectedData.filter(item => !idlist.includes(item.deptId))
    },
    checkItem() {
      if (this.type === 'dept') {
        this.checkedKeys = this.selectedData.map(item => {
          return item.deptId
        })
        this.selectedKeys = this.checkedKeys
      }
    },
    deleteUser(userId) {
      this.selectedUser = this.selectedUser.filter(item => item.userId !== userId)
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            if (user.userId === userId) {
              user.checked = false
            }
          })
        }
        return item
      })
      this.$forceUpdate()
    },
    getIds(deptId) { //根据传入的deptid 通过递归查找所有相关父子
      let idList = []
      const vm = this
      const getStr = function (list) {
        list.forEach(function (row) {
          idList.push(row.deptId)
          if (row.children) {
            getStr(row.children)
          }
        })
      }
      const getList = function (parentId) {
        XEUtils.eachTree(vm.treeData, item => {
          if (item.deptId === parentId) {
            idList.push(item.deptId)
            if (item.parentId > 0) {
              getList(item.parentId)
            }
          }
        })
      }
      XEUtils.eachTree(this.treeData, item => {
        if (item.deptId === deptId) {
          if (item.children) {
            getStr(item.children)
          }
          getList(item.deptId)
        }
      })
      return idList
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys;
      // this.selectedData = checkedNodes;
      this.selectedData = checkedNodes.map(item => {
        return {
          deptId: item.data.props.deptId,
          deptName: item.data.props.deptName
        }
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
    },
    getSelectData() {
      return {
        type: this.type,
        deptIds: this.returnValue.map(item => {
          return item.deptId
        }).toString(),
        userIds: this.returnValue.map(item => {
          return item.userId
        }).toString()
      }
    },
    setData(type, ids, names) {
      type === 1 ? this.type = 'customer' : this.type = 'dept'
      this.returnValue = ids.split(',').map((item, index) => {
        if (type === 1) {
          return {
            userId: parseInt(item),
            userName: names.split(',')[index]
          }
        } else {
          return {
            deptId: parseInt(item),
            deptName: names.split(',')[index]
          }
        }
      })
      this.selectedUser = this.returnValue
      this.selectedData = this.returnValue
      this.checkItem()
    }
  },
};
</script>
<style scoped lang="less">
ul {
  list-style-type: none;
}

.ant-input {
  height: auto;
  min-height: 32px;
  min-width: 200px;
}

.a-icon {
  position: absolute;
  z-index: 10;
  right: 6px;
  top: 13px;
  pointer-events: none;
}

input {
  cursor: pointer
}

.tag-select {
  max-height: 700px;
  overflow: hidden;
  //border: 1px solid #999;
  margin-top: 24px;
}

.user-box {
  margin-top: 16px;
  display: flex;

  .left {
    padding: 0 24px;
    flex: 1;
    border-right: 1px solid #000;

    .search-box {
      display: flex;

      button {
        margin-left: 12px;
      }
    }

    .tree-box {
      margin-top: 16px;
      overflow-y: scroll;
      height: 600px;
    }
  }

  .right {
    flex: 1;
    padding: 0 24px;
    color: #333;

    .selected {
      margin-top: 16px;
      list-style-type: none;
      overflow-y: scroll;
      height: 614px;

      li {
        display: flex;
        line-height: 24px;
        padding-right: 24px;

        i {
          margin-left: auto;
          cursor: pointer;
        }
      }
    }
  }

}

</style>

